import React from "react";
import { Box, Button } from "@mui/material";
import dayjs from "dayjs";

const presets = [
  { label: "Start", hour: 0, minute: 0 },
  { label: "Noon", hour: 12, minute: 0 },
  { label: "End", hour: 23, minute: 59 },
];

const buttonSx = {
  minWidth: 0,
  px: 1,
  py: 0.25,
  fontSize: "11px",
  lineHeight: 1.4,
  textTransform: "none",
  borderColor: "#d9d9d9",
  color: "#333",
  "&:hover": {
    borderColor: "#142C5C",
    color: "#142C5C",
    background: "#e8edf5",
  },
};

const TimePresetButtons = ({ value, onChange }) => {
  const applyPreset = (hour, minute) => {
    const base = value || dayjs();
    onChange(base.hour(hour).minute(minute).second(0));
  };

  return (
    <Box sx={{ display: "flex", gap: 0.5, mt: 0.5 }}>
      <Button
        size="small"
        variant="outlined"
        onClick={() => onChange(dayjs())}
        sx={buttonSx}
      >
        Now
      </Button>
      <Button
        size="small"
        variant="outlined"
        onClick={() => onChange(dayjs().add(1, "minute"))}
        sx={buttonSx}
      >
        +1 Min
      </Button>
      {presets.map((preset) => (
        <Button
          key={preset.label}
          size="small"
          variant="outlined"
          onClick={() => applyPreset(preset.hour, preset.minute)}
          sx={buttonSx}
        >
          {preset.label}
        </Button>
      ))}
    </Box>
  );
};

export default TimePresetButtons;
